"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = IconButton;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _media = require("react-components/media");

var _loading = require("../loading");

var _styles = require("react-components/styles");

var _styles2 = require("./styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _routerLink = _interopRequireDefault(require("../links/router-link"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["icon", "iconSize", "isSubmitting", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Icon color themes.
 */
var iconColorThemes = _objectSpread(_objectSpread({}, _styles2.colorThemes), {}, {
  transparent: {
    backgroundColor: 'transparent',
    color: (0, _styles.color)('secondary'),
    disabled: {
      color: (0, _styles.color)('blue200')
    },
    interaction: {
      color: (0, _styles.color)('blue500')
    }
  }
});
/**
 * `Size` type.
 */


/**
 * Icon button themes.
 */
var iconButtonThemes = Object.entries(iconColorThemes).reduce(function (result, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      themeName = _ref2[0],
      themeSchema = _ref2[1];

  return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, themeName, (0, _styledComponents.css)(["background-color:", ";color:", ";", " &:focus,&:hover{background-color:", ";color:", ";}"], (0, _get2["default"])(themeSchema, 'backgroundColor'), (0, _get2["default"])(themeSchema, 'color'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _get2["default"])(themeSchema, 'disabled.backgroundColor'), (0, _get2["default"])(themeSchema, 'disabled.color'))), (0, _get2["default"])(themeSchema, 'interaction.backgroundColor'), (0, _get2["default"])(themeSchema, 'interaction.color'))));
}, {});
/**
 * `Button` styled component.
 */

var Button = _styledComponents["default"].button.attrs(function (_ref3) {
  var as = _ref3.as,
      href = _ref3.href,
      to = _ref3.to,
      type = _ref3.type;
  var element = as || to && _routerLink["default"] || href && 'a' || 'button';
  return {
    as: element,
    type: type || (element === 'button' ? 'button' : null)
  };
}).withConfig({
  displayName: "icon-button__Button",
  componentId: "sc-1bvisnl-0"
})(["align-items:center;appearance:none;border:0;border-radius:", "px;cursor:pointer;display:flex;justify-content:center;line-height:11px;outline:none;padding:0;position:relative;transition:", ";transition-property:background-color,color;", " ", " ", ""], (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["cursor:default;pointer-events:none;"])), (0, _styledTools.switchProp)('size', {
  large: (0, _styledComponents.css)(["height:48px;width:48px;"]),
  medium: (0, _styledComponents.css)(["height:36px;width:36px;"]),
  small: (0, _styledComponents.css)(["height:32px;width:32px;"])
}, (0, _styledComponents.css)(["height:", ";width:", ";"], (0, _styledTools.prop)('size'), (0, _styledTools.prop)('size'))), (0, _styledTools.switchProp)('colorTheme', iconButtonThemes));
/**
 * `StyledLoading` styled component.
 */


var StyledLoading = (0, _styledComponents["default"])(_loading.Loading).withConfig({
  displayName: "icon-button__StyledLoading",
  componentId: "sc-1bvisnl-1"
})(["left:initial;top:initial;transform:none;"]);
/**
 * Get icon size.
 */

function getIconSize(size) {
  switch (size) {
    case 'large':
      return '32px';

    case 'medium':
      return '20px';

    case 'small':
      return '16px';

    default:
      return null;
  }
}
/**
 * Export `IconButton` component.
 */


function IconButton(props) {
  var _getIconSize;

  var icon = props.icon,
      iconSize = props.iconSize,
      isSubmitting = props.isSubmitting,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Button, _extends({}, rest, {
    size: size
  }), isSubmitting ? /*#__PURE__*/_react["default"].createElement(StyledLoading, {
    active: true,
    relative: true
  }) : /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    icon: icon,
    size: (_getIconSize = getIconSize(iconSize)) !== null && _getIconSize !== void 0 ? _getIconSize : iconSize
  }));
}